import React from "react";

import DataItems from "@Components/shared/DataItems";
import DynamicTable from "@Components/shared/DynamicTable";
import LargeSpinner from "@Components/shared/LargeSpinner";
import PageHelmet from "@Components/shared/PageHelmet";
import { DateTime, pluralise } from "@Utils";
import { Card, Col, Radio, Row } from "antd";
import useAdminUsers from "./hooks/useAdminUsers";
import { IAssessmentView } from "./types";

const AdminUsersView: React.FC<IAssessmentView> = ({ tab }) => {
    const {
        assessment,
        assessmentInstances,
        data,
        columnData,
        isFetching,
        isLoading,
        userCount,

        onReload,
        onSubmissionTypeChange,
    } = useAdminUsers();

    if (!assessment) return null;

    const submissions = assessmentInstances.filter((ai) => ["submitted", "completed"].includes(ai.status)).length;

    return (
        <article className={`admin-submissions-view ${tab}-tab`}>
            <PageHelmet name={"Assessments Admin Users View"} />
            <section>
                {isLoading && <LargeSpinner />}
                {!isLoading && (
                    <Row gutter={[16, 16]}>
                        {/* top row */}
                        <Col span={12}>
                            <Card className="newUI-subtle">
                                <Card.Grid className="full-width" hoverable={false}>
                                    <DataItems
                                        data={[
                                            { heading: "Name", content: assessment.name },
                                            { heading: "Users", content: userCount },
                                            { heading: "Submissions", content: submissions },
                                        ]}
                                    />
                                </Card.Grid>
                            </Card>
                        </Col>
                        <Col span={12}>
                            <Card className="newUI-subtle">
                                <Card.Grid className="full-width" hoverable={false}>
                                    <DataItems
                                        data={[
                                            {
                                                heading: "Start Date",
                                                content: DateTime(assessment.startDate).format("MMM Do YYYY"),
                                            },
                                            {
                                                heading: "End Date",
                                                content: DateTime(assessment.endDate).format("MMM Do YYYY"),
                                            },
                                            {
                                                heading: "Late Submission Allowance",
                                                content:
                                                    assessment.lateSubmissions +
                                                    " " +
                                                    pluralise("day", assessment.lateSubmissions),
                                            },
                                        ]}
                                    />
                                </Card.Grid>
                            </Card>
                        </Col>
                        {/* middle row */}
                        <Col span={24}>
                            <Card className="newUI-subtle">
                                <Card.Grid className="full-width" hoverable={false}>
                                    <Row justify="center">
                                        <Radio.Group
                                            className="newUI-raised"
                                            onChange={({ target }) => onSubmissionTypeChange(target.value)}
                                            defaultValue=""
                                        >
                                            <Radio.Button value="">All</Radio.Button>
                                            {data?.status?.buttons?.map((button) => (
                                                <Radio.Button
                                                    disabled={button.disabled}
                                                    key={button.key}
                                                    value={button.key}
                                                >
                                                    {button.title}
                                                </Radio.Button>
                                            ))}
                                        </Radio.Group>
                                    </Row>
                                </Card.Grid>
                            </Card>
                        </Col>
                        {/* bottom row */}
                        <Col span={24}>
                            <Card className="newUI-subtle">
                                <Card.Grid className="full-width" hoverable={false}>
                                    <DynamicTable
                                        dataSource={assessmentInstances}
                                        columnData={columnData}
                                        isLoading={isLoading}
                                        isFetching={isFetching}
                                        pagination={{ pageSize: 5, position: ["bottomRight"] }}
                                        menuOptions={{ onReload }}
                                        rowKey="assessmentId"
                                    />
                                </Card.Grid>
                            </Card>
                        </Col>
                    </Row>
                )}
            </section>
        </article>
    );
};

export default AdminUsersView;
